<div class="cnt-column" style="height: 100%">
    <ng-container *ngIf="parent.disableScroll; else enableScroll">
        <ng-container *ngTemplateOutlet="optionsTemplate"></ng-container>
    </ng-container>

    <ng-template #enableScroll>
        <scrolldiv style="flex: 1; width: 100%"
                   [scrollerSize]="20"
                   [navigatorSize]="14"
                   [scrollVerticalIndent]="0"
                   cls="lightScroll">
            <ng-container *ngTemplateOutlet="optionsTemplate"> </ng-container>
        </scrolldiv>
    </ng-template>
</div>

<ng-template #optionsTemplate>
    <div class="close-cnt cnt-row">
        <div class="filler"></div>
        <div class="upgrade-btn-close"
             (click)="onClose()"
             data-testid="closeBtn">
        </div>
        <div [width]="10"></div>
    </div>

    <div [height]="50"></div>

    <div class="cnt-column-centered card-container-wrap">
        <div class="cnt-column-centered card-container">


            <span class="header-text-font-brixx" style="font-weight: 600; font-size: 52px" i18n>{{ 'UPGRADE_TO_A_PAID' | translate }}</span>
            <span class="header-text-font-brixx" style="color: #424A5D; font-weight: 400; font-size: 20px; margin-top: 15px " i18n>
                {{ 'ELEVATE_YOUR_BUSINESS_STRATEGY' | translate }}
            </span>

            <div [height]="45"></div>

            <div class="cnt-row" style="justify-content: center">

                <div class="new-product-card-brixx white-background">
                    <upgrade>

                    </upgrade>
                </div>
            </div>
        </div>
    </div>
</ng-template>